  import React, { useState, useRef, useEffect, useCallback } from 'react';
import './insertion-sections.css';
import { FaCopy, FaTimes, FaMinus, FaPlus, FaKeyboard } from 'react-icons/fa';
import HoverTooltip from '../tooltips/HoverTooltip';

const SectionsOverlay = ({
  isOpen,
  onClose,
  sections,
  onCopySection,
  copiedSections = []
}) => {
  const [isMinimized, setIsMinimized] = useState(false);
  const overlayRef = useRef(null);


  // Handle section copy
  const handleSectionCopy = useCallback((section, index) => {
    onCopySection(
      section.content || '',
      (section.title && typeof section.title === 'string' ? section.title : null) || `Section ${index + 1}`,
      index
    );
  }, [onCopySection]);

  // Keyboard shortcuts with preventDefault
  useEffect(() => {
    const handleKeyDown = (e) => {
      if (!isOpen || !sections) return;

      if (e.ctrlKey || e.metaKey) {
        const num = parseInt(e.key);
        if (num >= 1 && num <= 9 && sections[num - 1]) {
          e.preventDefault();
          e.stopPropagation();
          handleSectionCopy(sections[num - 1], num - 1);
        }
      }
    };

    document.addEventListener('keydown', handleKeyDown, true); // Use capture phase
    return () => document.removeEventListener('keydown', handleKeyDown, true);
  }, [isOpen, sections, handleSectionCopy]);

  if (!isOpen || !sections || sections.length === 0) return null;

  const validSections = sections.filter(section =>
    section && typeof section === 'object' && !Array.isArray(section)
  );

  return (
    <div
      ref={overlayRef}
      className={`insertion-sections-overlay ${isMinimized ? 'minimized' : ''}`}
    >
      <div className="insertion-sections-overlay-header">
        <div className="header-left">
          <h3>Sections du rapport</h3>
        </div>
        <div className="header-actions">
          <button
            className="minimize-btn"
            onClick={() => setIsMinimized(!isMinimized)}
            title={isMinimized ? "Agrandir" : "Réduire"}
          >
            {isMinimized ? <FaPlus /> : <FaMinus />}
          </button>
          <button
            className="close-btn"
            onClick={onClose}
            title="Fermer"
          >
            <FaTimes />
          </button>
        </div>
      </div>

      {!isMinimized && (
        <>
          <div className="insertion-sections-overlay-info">
            <FaKeyboard  />
            <span>Cliquez pour copier ou utilisez Ctrl+1 à 9</span>
          </div>

          <div className="insertion-sections-overlay-content">
            <div className="insertion-sections-list">
              {validSections.map((section, filteredIndex) => {
                const originalIndex = sections.indexOf(section);
                const isCopied = copiedSections.includes(originalIndex);
                const shortcutKey = originalIndex + 1;

                return (
                  <div
                    key={originalIndex}
                    className={`insertion-sections-item ${isCopied ? 'copied' : ''}`}
                  >
                    <HoverTooltip
                      text={`${isCopied ? 'Déjà copié - ' : ''}Cliquer pour copier (Ctrl+${shortcutKey})`}
                      position="left"
                    >
                      <button
                        onClick={() => handleSectionCopy(section, originalIndex)}
                        className="insertion-sections-button"
                      >
                        <span className="insertion-sections-number">{shortcutKey}</span>
                        <span className="insertion-sections-separator">-</span>
                        <span className="insertion-sections-title">
                          {section.title && typeof section.title === 'string'
                            ? section.title.slice(0, 60)
                            : `Section ${originalIndex + 1}`}
                        </span>
                        <FaCopy className="insertion-sections-copy-icon" />
                      </button>
                    </HoverTooltip>
                  </div>
                );
              })}
            </div>
          </div>

          <div className="insertion-sections-overlay-footer">
            <span className="insertion-sections-count">
              {validSections.length} section{validSections.length > 1 ? 's' : ''} disponible{validSections.length > 1 ? 's' : ''}
            </span>
            {copiedSections.length > 0 && (
              <span className="insertion-sections-copied-count">
                {copiedSections.length} copiée{copiedSections.length > 1 ? 's' : ''}
              </span>
            )}
          </div>

        </>
      )}
    </div>
  );
};

export default SectionsOverlay;